import uniq from 'lodash/uniq';
import { setProspectDetailsChangeBaseline } from '@changeTracking/pages/prospectDetails/formChangeTracking';

import { fetchProspectDetails, getCustomerLookup } from './services';
import { setProspectDetailsStore } from './store';
import { ProspectData } from './types';

export const getProspectDetails = async (id: number) => {
  try {
    setProspectDetailsStore('loading', true);
    const res = await fetchProspectDetails(id);
    if (res && res.isSuccess) {
      setProspectDetailsStore('prospectDetails', res.value);
      setProspectDetailsChangeBaseline(res.value);
      const res1 = await getCustomerLookup({
        name: res.value.name,
      });
      setProspectDetailsStore('customerMatches', uniq(res1?.value || []));
    }
  } finally {
    setProspectDetailsStore('loading', false);
  }
};

export const updateProspectDetails = (updates: Partial<ProspectData>) => {
  Object.entries(updates).forEach(([key, value]) => {
    setProspectDetailsStore(
      'prospectDetails',
      key as keyof ProspectData,
      value,
    );
  });
};
